import { LOGOUT_REQUEST } from "../../Auth/slices/authActions";
import {
  GET_SHOPS_FAILURE,
  GET_SHOPS_REQUEST,
  GET_SHOPS_SUCCESS,
} from "./shopActions";

const initState = {
  data: [],
  isLoading: false,
  errorMessage: "",
};

const shopReducer = (state = initState, action) => {
  switch (action.type) {
    case LOGOUT_REQUEST:
      return {
        ...state,
        isLoading: false,
        data: [],
      };
    case GET_SHOPS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case GET_SHOPS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload,
      };
    case GET_SHOPS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
};

export default shopReducer;
